import { render } from "./IntercomScript.vue?vue&type=template&id=40ad97fe"
import script from "./IntercomScript.vue?vue&type=script&lang=js"
export * from "./IntercomScript.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__